<template>
  <v-app>
    <v-navigation-drawer app v-if="isLoggedIn && !isMobile" permanent>
      <div v-if="isLoggedIn">
        <v-toolbar flat class="transparent" @click="setRoute('/account')">
          <v-list class="pa-0">
            <v-list-tile avatar>
              <v-list-tile-avatar>
                <img :src="photoURL">
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title>{{displayName}}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-toolbar>
        <v-list class="pt-0" dense>
          <v-divider></v-divider>
          <v-list-tile @click="setRoute('/lists')">
            <v-list-tile-action>
              <v-icon>list</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>
                My Lists
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile @click="setRoute('/lists/shared')">
            <v-list-tile-action>
              <v-icon>folder_shared</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>
                Shared Lists
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile @click="logout">
            <v-list-tile-action>
              <v-icon>exit_to_app</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>
                Logout
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </div>
    </v-navigation-drawer>

    <v-footer>
      <!-- shift -->
      <v-bottom-nav :value="true" :active.sync="bottomNavPos" fixed color="white" v-if="isLoggedIn && isMobile" app>
        <v-btn flat color="primary" value="lists" @click="setRoute('/lists')">
          <span>Lists</span>
          <v-icon>list</v-icon>
        </v-btn>
        <v-btn flat color="primary" value="account" @click="setRoute('/account')">
          <span>Account</span>
          <v-icon>person</v-icon>
        </v-btn>
      </v-bottom-nav>
    </v-footer>

    <v-toolbar app class="primary">
      <!-- <v-toolbar-side-icon v-if="isLoggedIn && !isMobile"></v-toolbar-side-icon> -->
      <v-toolbar-title>SmartShoppingList</v-toolbar-title>
    </v-toolbar>
    <v-content>
      <v-container fluid>
        <router-view></router-view>
      </v-container>
    </v-content>
    <!-- <v-footer app></v-footer> -->
  </v-app>
</template>

<script>
import './assets/css/global.css';
import firebase from 'firebase/app';
import 'firebase/auth';

export default {
  name: 'vue-app',
  data() {
    return {
      bottomNavPos: 'lists'
    };
  },
  computed: {
    isLoggedIn: function() {
      if (this.$store.state.user.uid != '') {
        return true;
      } else {
        return false;
      }
    },
    displayName: function() {
      return this.$store.state.user.displayName;
    },
    photoURL: function() {
      return this.$store.state.user.photoURL;
    },
    currentBreakpoint: function() {
      return this.$vuetify.breakpoint;
    },
    isMobile: {
      get: function() {
        return this.$store.state.isMobile;
      },
      set: function(val) {
        this.$store.state.isMobile = val;
      }
    }
  },
  methods: {
    setRoute: function(route) {
      this.$router.push(route);
    },
    logout: function() {
      firebase
        .auth()
        .signOut()
        .then(
          function() {
            this.$store.state.user.uid = '';
            this.$store.state.user.displayName = '';
            this.$store.state.user.photoURL = '';
            this.setRoute('/login');
          }.bind(this)
        );
    },
    mediaCheck: function() {
      if (window.matchMedia('(max-width: 700px)').matches) {
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }
    }
  },
  mounted() {
    this.mediaCheck();

    window.onresize = function() {
      this.mediaCheck();
    }.bind(this);
  }
};
</script>
